$(function(){

    var $bannerWrapper = $('.banner-wrapper');
    $bannerWrapper.on('init', function(slick) {
        $bannerWrapper.fadeIn(3000);
    }).slick({
        infinite: true,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000 // 5 seconds
        //fade: true,
        //slidesToShow: 3
    });

    $('.slick-next').click(function() {
        $bannerWrapper.slick('slickNext');
    });
    $('.slick-prev').click(function() {
        $bannerWrapper.slick('slickPrev');
    });
});
